import { render } from "./nyheder.vue?vue&type=template&id=0df948fe&ts=true"
import script from "./nyheder.vue?vue&type=script&lang=ts"
export * from "./nyheder.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__